import { FAQ_DATA } from '@constant/faq';
import { PATHS_BY_ENV } from '@constant/paths';
import { env } from '@helpers/EnvHelper';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Divider, Grid, Link, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
	wrapFAQAccordion: {
		width: '100%',
		'& .MuiAccordionSummary-content': {
			margin: '0px'
		},
		'& .MuiButtonBase-root': {
			padding: '16px 24px',
			[theme.breakpoints.down('sm')]: {
				padding: '16px 0px'
			}
		},
		'& .MuiAccordion-root': {
			position: 'inherit',
			borderRadius: '8px',
			[theme.breakpoints.up('sm')]: {
				marginBottom: '16px'
			}
		},
		'& .MuiAccordionDetails-root': {
			padding: '0px',
			color: theme.text.tertiary,
			borderBottomLeftRadius: '8px',
			WebkitBorderBottomRightRadius: '8px',
			[theme.breakpoints.up('sm')]: {
				padding: '16px 24px',
				background: theme.surfaces.level3,
				color: theme.surfaces.contrastText
			}
		},
		'& .MuiAccordionSummary-content.Mui-expanded': {
			margin: '0px'
		},
		'& .MuiTypography-body1': {
			fontWeight: 700,
			'& a': {
				color: 'inherit'
			}
		}
	}
}));

const FAQ = () => {
	const { classes } = useStyles();
	const { t } = useTranslation();
	const theme = useTheme();

	const getFaqDescription = (description) => {
		const cleanContent = description;

		return <Typography variant="body1" dangerouslySetInnerHTML={{ __html: cleanContent }} />;
	};

	return (
		<>
			<Grid container direction="column" sx={{ width: '100%' }} alignItems="center">
				<Grid item sx={{ py: '32px', display: { xs: 'none', sm: 'block' } }}>
					<Typography variant="h3">{t('FREQUENTLY_ASKED_QUESTIONS')}</Typography>
				</Grid>
				<Grid item sx={{ display: { xs: 'block', sm: 'none', width: '100%' } }}>
					<Typography variant="h6" color={theme.surfaces.contrastText}>
						{t('FAQ')}
					</Typography>
					<Divider />
				</Grid>
				<Grid item sx={{ width: '100%' }}>
					<Box className={classes.wrapFAQAccordion}>
						{FAQ_DATA?.map((faq, index) => (
							<Accordion key={index} sx={{ boxShadow: { xs: 'none', sm: '0px 5px 15px rgba(0, 0, 0, 0.05)' } }}>
								<AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
									<Typography variant="h6" color={theme.surfaces.contrastText}>
										{faq.title}
									</Typography>
								</AccordionSummary>
								<AccordionDetails>{getFaqDescription(faq?.description)}</AccordionDetails>
							</Accordion>
						))}
					</Box>
				</Grid>
				<Grid item>
					<Grid container direction="column" justifyContent="center" alignItems="center" sx={{ py: '32px', gap: 1 }}>
						<Typography variant="h4" color={theme.text.secondary}>
							{t('HAVING_ISSUES_WITH_RECEVING_FUNDS')}
						</Typography>
						<Button
							LinkComponent={Link}
							href={PATHS_BY_ENV[env].supportCenterLink}
							variant="text"
							color="inherit"
							sx={{
								'&:hover': {
									background: 'none'
								},
								width: 'fit-content',
								padding: '16px',
								minHeight: '0px'
							}}>
							<Typography variant="h6" borderBottom={`2px solid ${theme.palette.text.primary}`}>
								{t('GO_TO_SUPPORT')}
							</Typography>
						</Button>
					</Grid>
				</Grid>
			</Grid>
		</>
	);
};

export default FAQ;
